import { createAxiosClient } from "./axios.factory";

export const axiosService = createAxiosClient();

export const axiosServiceWithoutToken = createAxiosClient(false);
